import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "portal-dashboard pa-4" }
const _hoisted_2 = { class: "hero mb-5" }
const _hoisted_3 = { class: "hero-av" }
const _hoisted_4 = { class: "hero-txt" }
const _hoisted_5 = { class: "hero-name" }
const _hoisted_6 = { class: "hero-sub" }
const _hoisted_7 = { class: "hero-date" }
const _hoisted_8 = { class: "kpi-value text-green-darken-2" }
const _hoisted_9 = { class: "kpi-sub text-medium-emphasis" }
const _hoisted_10 = { class: "kpi-sub text-medium-emphasis" }
const _hoisted_11 = { class: "kpi-value text-teal-darken-2" }
const _hoisted_12 = { class: "kpi-sub text-medium-emphasis" }
const _hoisted_13 = { class: "action-title" }
const _hoisted_14 = { class: "action-sub text-medium-emphasis text-caption" }
const _hoisted_15 = { class: "section-header" }
const _hoisted_16 = { class: "font-weight-bold" }
const _hoisted_17 = { class: "text-right font-weight-bold text-red-darken-1" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "section-header" }
const _hoisted_20 = { class: "colegi-list" }
const _hoisted_21 = {
  key: 0,
  class: "text-center text-medium-emphasis py-3"
}
const _hoisted_22 = { class: "section-header" }
const _hoisted_23 = { class: "section-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_CalendarConcedii = _resolveComponent("CalendarConcedii")!
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "text-center py-8"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  color: "#ff5722",
                  size: "48"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_ctx.dashboard)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.heroInitiale), 1),
              _createElementVNode("div", _hoisted_4, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "hero-hi" }, "Bună ziua,", -1)),
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.dashboard.NumeAngajat), 1),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_v_icon, {
                    size: "14",
                    class: "mr-1"
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("mdi-office-building-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _createTextVNode(_toDisplayString(_ctx.dashboard.Departament || '—') + " ", 1),
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "hero-dot" }, "•", -1)),
                  _createVNode(_component_v_icon, {
                    size: "14",
                    class: "mr-1"
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("mdi-badge-account-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _createTextVNode(_toDisplayString(_ctx.dashboard.Functie || '—'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_v_icon, {
                  size: "16",
                  class: "mr-1"
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("mdi-calendar-today", -1)
                  ]))]),
                  _: 1
                }),
                _createTextVNode(_toDisplayString(_ctx.aziStr), 1)
              ])
            ]),
            _createVNode(_component_v_row, { class: "kpi-row mb-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "6",
                  md: "3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "kpi-card",
                      color: "green-lighten-5",
                      elevation: "2",
                      rounded: "xl"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, { class: "text-center py-2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              size: "22",
                              color: "green-darken-2",
                              class: "mb-2"
                            }, {
                              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                _createTextVNode("mdi-umbrella-beach", -1)
                              ]))]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.dashboard.ZileCODisponibile), 1),
                            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "kpi-label" }, "Zile CO disponibile", -1)),
                            _createElementVNode("div", _hoisted_9, "Folosite: " + _toDisplayString(_ctx.dashboard.ZileCOFolosite), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "6",
                  md: "3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "kpi-card",
                      color: _ctx.dashboard.CereriConcediuInAsteptare > 0 ? 'amber-lighten-5' : 'grey-lighten-5',
                      elevation: "2",
                      rounded: "xl"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, { class: "text-center py-2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              size: "22",
                              color: _ctx.dashboard.CereriConcediuInAsteptare > 0 ? 'amber-darken-2' : 'grey',
                              class: "mb-2"
                            }, {
                              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                _createTextVNode("mdi-clock-outline", -1)
                              ]))]),
                              _: 1
                            }, 8, ["color"]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["kpi-value", _ctx.dashboard.CereriConcediuInAsteptare > 0 ? 'text-amber-darken-2' : 'text-grey'])
                            }, _toDisplayString(_ctx.dashboard.CereriConcediuInAsteptare), 3),
                            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "kpi-label" }, "Cereri în așteptare", -1)),
                            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "kpi-sub text-medium-emphasis" }, "Concedii", -1))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "6",
                  md: "3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "kpi-card",
                      color: _ctx.dashboard.TicheteInAsteptare > 0 ? 'blue-lighten-5' : 'grey-lighten-5',
                      elevation: "2",
                      rounded: "xl"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, { class: "text-center py-2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              size: "22",
                              color: _ctx.dashboard.TicheteInAsteptare > 0 ? 'blue-darken-2' : 'grey',
                              class: "mb-2"
                            }, {
                              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                _createTextVNode("mdi-ticket-outline", -1)
                              ]))]),
                              _: 1
                            }, 8, ["color"]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["kpi-value", _ctx.dashboard.TicheteInAsteptare > 0 ? 'text-blue-darken-2' : 'text-grey'])
                            }, _toDisplayString(_ctx.dashboard.TicheteInAsteptare), 3),
                            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "kpi-label" }, "Tichete deschise", -1)),
                            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "kpi-sub text-medium-emphasis" }, "HR", -1))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "6",
                  md: "3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "kpi-card",
                      color: _ctx.dashboard.PontajPlecareLipsaAzi ? 'red-lighten-5' : 'green-lighten-5',
                      elevation: "2",
                      rounded: "xl"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, { class: "text-center py-2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              size: "22",
                              color: _ctx.dashboard.PontajPlecareLipsaAzi ? 'red-darken-2' : 'green-darken-2',
                              class: "mb-2"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.dashboard.PontajPlecareLipsaAzi ? 'mdi-door-open' : 'mdi-check-circle'), 1)
                              ]),
                              _: 1
                            }, 8, ["color"]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["kpi-value", _ctx.dashboard.PontajPlecareLipsaAzi ? 'text-red-darken-2' : 'text-green-darken-2'])
                            }, _toDisplayString(_ctx.dashboard.PontajPlecareLipsaAzi ? '!' : 'OK'), 3),
                            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "kpi-label" }, "Pontaj azi", -1)),
                            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.dashboard.PontajPlecareLipsaAzi ? 'Plecare lipsă' : 'Complet'), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "6",
                  md: "3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "kpi-card",
                      color: "teal-lighten-5",
                      elevation: "2",
                      rounded: "xl"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, { class: "text-center py-2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              size: "22",
                              color: "teal-darken-2",
                              class: "mb-2"
                            }, {
                              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                _createTextVNode("mdi-account-group", -1)
                              ]))]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.dashboard.ColegiInCOAstazi), 1),
                            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "kpi-label" }, "Colegi în CO astăzi", -1)),
                            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.dashboard.VedeToataFirma ? 'Toată firma' : 'Departamentul tău'), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.dashboard.EsteManager)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "12",
                      sm: "6",
                      md: "3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          class: "kpi-card",
                          color: _ctx.dashboard.CereriDeAprobat > 0 ? 'orange-lighten-5' : 'grey-lighten-5',
                          elevation: "2",
                          rounded: "xl",
                          style: {"cursor":"pointer"},
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'PortalAprobari' })))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "text-center py-2" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  size: "22",
                                  color: _ctx.dashboard.CereriDeAprobat > 0 ? 'orange-darken-2' : 'grey',
                                  class: "mb-2"
                                }, {
                                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                    _createTextVNode("mdi-clipboard-check-outline", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["color"]),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["kpi-value", _ctx.dashboard.CereriDeAprobat > 0 ? 'text-orange-darken-2' : 'text-grey'])
                                }, _toDisplayString(_ctx.dashboard.CereriDeAprobat), 3),
                                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "kpi-label" }, "Cereri de aprobat", -1)),
                                _cache[19] || (_cache[19] = _createElementVNode("div", { class: "kpi-sub text-medium-emphasis" }, "Ca manager", -1))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["color"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actiuniRapide, (act) => {
                  return (_openBlock(), _createBlock(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    md: "3",
                    key: act.route
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "action-card",
                        elevation: "1",
                        rounded: "xl",
                        onClick: ($event: any) => (_ctx.$router.push({ name: act.route })),
                        ripple: true,
                        style: {"cursor":"pointer"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_text, { class: "d-flex align-center pa-4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_avatar, {
                                color: act.color,
                                size: "44",
                                class: "mr-3"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    color: "white",
                                    size: "22"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(act.icon), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["color"]),
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_13, _toDisplayString(act.title), 1),
                                _createElementVNode("div", _hoisted_14, _toDisplayString(act.sub), 1)
                              ]),
                              _createVNode(_component_v_spacer),
                              _createVNode(_component_v_icon, { color: "grey-lighten-1" }, {
                                default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                  _createTextVNode("mdi-chevron-right", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { class: "mt-2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "section-card",
                      elevation: "1",
                      rounded: "xl"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_v_icon, {
                            size: "18",
                            class: "mr-2",
                            color: "#ff5722"
                          }, {
                            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                              _createTextVNode("mdi-history", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[22] || (_cache[22] = _createTextVNode("Istoric concedii", -1))
                        ]),
                        _createVNode(_component_v_table, { density: "compact" }, {
                          default: _withCtx(() => [
                            _cache[24] || (_cache[24] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, "An"),
                                _createElementVNode("th", null, "Tip"),
                                _createElementVNode("th", { class: "text-right" }, "Zile")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.istoric, (it, i) => {
                                return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                  _createElementVNode("td", _hoisted_16, _toDisplayString(it.An), 1),
                                  _createElementVNode("td", null, _toDisplayString(it.Tip || '—'), 1),
                                  _createElementVNode("td", _hoisted_17, _toDisplayString(it.Zile), 1)
                                ]))
                              }), 128)),
                              (!_ctx.istoric.length)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [...(_cache[23] || (_cache[23] = [
                                    _createElementVNode("td", {
                                      colspan: "3",
                                      class: "text-center text-medium-emphasis py-3"
                                    }, "Fără date", -1)
                                  ]))]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "section-card",
                      elevation: "1",
                      rounded: "xl"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_v_icon, {
                            size: "18",
                            class: "mr-2",
                            color: "green-darken-1"
                          }, {
                            default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                              _createTextVNode("mdi-account-group", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[26] || (_cache[26] = _createTextVNode("Colegi în CO astăzi ", -1)),
                          _createVNode(_component_v_chip, {
                            size: "x-small",
                            color: "green-darken-1",
                            class: "ml-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.colegiAzi.length), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colegiAzi, (c, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: i,
                              class: "coleg-item"
                            }, [
                              _cache[27] || (_cache[27] = _createElementVNode("span", { class: "dot" }, null, -1)),
                              _createTextVNode(_toDisplayString(c), 1)
                            ]))
                          }), 128)),
                          (!_ctx.colegiAzi.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, "Niciun coleg în CO astăzi"))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "section-card",
                      elevation: "1",
                      rounded: "xl"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_v_icon, {
                            size: "18",
                            class: "mr-2",
                            color: "#ff5722"
                          }, {
                            default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                              _createTextVNode("mdi-calendar-month", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[29] || (_cache[29] = _createTextVNode("Planificare concedii — toată firma", -1))
                        ]),
                        _createVNode(_component_CalendarConcedii, {
                          items: _ctx.calendarItems,
                          holidays: _ctx.sarbatori,
                          "initial-date": _ctx.calendarDate
                        }, null, 8, ["items", "holidays", "initial-date"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "section-card",
                      elevation: "1",
                      rounded: "xl"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_component_v_icon, {
                            size: "18",
                            class: "mr-2",
                            color: "purple-darken-1"
                          }, {
                            default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                              _createTextVNode("mdi-home-account", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[31] || (_cache[31] = _createTextVNode("Munca de acasă (WFH) — toată firma", -1))
                        ]),
                        _createVNode(_component_CalendarConcedii, {
                          items: _ctx.wfhItems,
                          holidays: _ctx.sarbatori,
                          "initial-date": _ctx.calendarDate
                        }, null, 8, ["items", "holidays", "initial-date"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 64))
        : (_ctx.error)
          ? (_openBlock(), _createBlock(_component_v_alert, {
              key: 2,
              type: "error",
              variant: "tonal"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.error), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
  ]))
}